import "./App.css";
import "@shopify/polaris/build/esm/styles.css";

import { AuthContextProvider } from "./context/AuthContext.js";
import { BranchContextProvider } from "./context/BranchContext.js";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import LogIn from "./components/LogIn/LogIn.js";
import Dashboard from "./components/Dashboard/Dashboard.js";
import CarBrands from "./components/Cars/Brands/CarBrands.js";
import CarModels from "./components/Cars/Models/CarModels.js";
import EditCarModel from "./components/Cars/Models/EditCarModel.js";
import Cars from "./components/Cars/Cars.js";
import EditCar from "./components/Cars/EditCar.js";
import Customers from "./components/Customers/Persons/Customers.js";
import CustomerEdit from "./components/Customers/Persons/CustomerEdit.js";
import Reservations from "./components/Reservations/Reservations.js";
import CreateReservation from "./components/Reservations/CreateReservation.js";
import Prices from "./components/Prices/Prices.js";
import Reservation from "./components/Reservations/Reservation.js";
import Cotizador from "./components/Cotizador/Cotizador.js";
import AllServices from "./components/Services/AllServices.js";
import NewService from "./components/Services/NewService.js";
import AllServiceProviders from "./components/Services/AllServiceProviders.js";
import NewServiceProvider from "./components/Services/NewServiceProvider.js";
import ViewService from "./components/Services/ViewService.js";
import AllEgresos from "./components/Egresos/AllEgresos.js";
import NewEgreso from "./components/Egresos/NewEgreso.js";
import ViewEgreso from "./components/Egresos/ViewEgreso.js";
import ServicesDashboard from "./components/Services/ServicesDashboard.js";
import Checklists from "./components/Services/Checklists.js";
import Checklist from "./components/Services/Checklist.js";
import PendingReports from "./components/Services/PendingReports.js";
import Washes from "./components/Washes/Washes.js";
import Wash from "./components/Washes/Wash.js";
import Users from "./components/Users/Users.js";
import EditUser from "./components/Users/EditUser.js";
import MenuSettings from "./components/Settings/MenuSettings.js";
import CompanySettings from "./components/Settings/CompanySettings.js";
import ViewServiceProvider from "./components/Services/ViewServiceProvider.js";
import ServicePrecheck from "./components/Services/ServicePrecheck.js";
import Car from "./components/Cars/Car.js";
import NewPolicy from "./components/Insurance/NewPolicy.js";
import AllInsurancePolicies from "./components/Insurance/AllInsurancePolicies.js";
import Policy from "./components/Insurance/Policy.js";
import OdometerSubmissions from "./components/Services/OdometerSubmissions.js";
import AfirmePayments from "./components/Banks/AfirmePayments.js";
import NewServiceOrder from "./components/Services/NewServiceOrder.js";
import NewFieldService from "./components/Services/NewFieldService.js";
import FieldCapture from "./components/Services/FieldCapture.js";
import Traslados from "./components/Traslados/Traslados.js";
import NewTraslado from "./components/Traslados/NewTraslado.js";
import Traslado from "./components/Traslados/Traslado.js";
import Trasladistas from "./components/Traslados/Trasladistas.js";
import TrasladoGastos from "./components/Traslados/TrasladoGastos.js";
import GastosFacturas from "./components/Traslados/GastosFacturas.js";
import CasetasTag from "./components/Traslados/CasetasTag.js";
import TrasladosPendientes from "./components/Traslados/TrasladosPendientes.js";
import TrasladoRates from "./components/Services/TrasladoRates.js";
import TrasladoRecovery from "./components/Services/TrasladoRecovery.js";
import InvoiceTracker from "./components/OtherUtilities/InvoiceTracker.js";
import Companies from "./components/Customers/Companies/Companies.js";
import CompanyEdit from "./components/Customers/Companies/CompanyEdit.js";
import OccupancyTimeline from "./components/Reservations/OccupancyTimeline.js";
import ConciliationDashboard from "./components/Invoicing/ConciliationDashboard.js";
import PendingDepositTransfers from "./components/Banks/PendingDepositTransfers.js";
import CreatePayment from "./components/Banks/CreatePayment.js";
import PagosRecibidos from "./components/Payments/PagosRecibidos.js";
import FintocStatement from "./components/Payments/FintocStatement.js";
import AutoInvoicingDashboard from "./components/Invoicing/AutoInvoicingDashboard.js";
import CreateInvoice from "./components/Invoicing/CreateInvoice.js";
import Invoices from "./components/Invoicing/Invoices.js";
import InvoicingGroupDetail from "./components/Invoicing/InvoicingGroupDetail.js";
import CashDaily from "./components/Cash/CashDaily.js";
import ConciliacionBancaria from "./components/Conciliacion/ConciliacionBancaria.js";
import Validaciones from "./components/Validaciones/Validaciones.js";
import NewValidacion from "./components/Validaciones/NewValidacion.js";
import ViewValidacion from "./components/Validaciones/ViewValidacion.js";
import ScannedDocuments from "./components/ScannedDocuments/ScannedDocuments.js";
import Infractions from "./components/Infractions/Infractions.js";
import NewInfraction from "./components/Infractions/NewInfraction.js";
import Infraction from "./components/Infractions/Infraction.js";
import Reports from "./components/Reports/Reports.js";
import Report from "./components/Reports/Report.js";
import VersionChecker from "./components/CustomComponents/VersionChecker/VersionChecker.js";

function App() {
  return (
    <AuthContextProvider>
      <BranchContextProvider>
      <BrowserRouter>
        <VersionChecker />
        <Routes>
          <Route path="/login" element={<LogIn />} />
          <Route path="/" element={<Dashboard />} />
          <Route path="/cotizador" element={<Cotizador />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/reservations/create" element={<CreateReservation />} />
          <Route path="/reservation" element={<Reservation />} />
          <Route path="/reservations" element={<Reservations />} />
          <Route path="/cars/models/edit" element={<EditCarModel />} />
          <Route path="/cars/models" element={<CarModels />} />
          <Route path="/cars/brands" element={<CarBrands />} />
          <Route path="/cars/edit" element={<EditCar />} />
          <Route path="/cars" element={<Cars />} />
          <Route path="/cars/:carId" element={<Car />} />
          <Route path="/reservations/timeline" element={<OccupancyTimeline />} />
          <Route path="/customers/edit" element={<CustomerEdit />} />
          <Route path="/customers" element={<Customers />} />
          <Route path="/companies" element={<Companies />} />
          <Route path="/companies/edit" element={<CompanyEdit />} />
          <Route path="/prices" element={<Prices />} />
          <Route path="/odometer_requests" element={<OdometerSubmissions />} />
          <Route path="/services_dashboard" element={<ServicesDashboard />} />
          <Route path="/services" element={<AllServices />} />
          <Route path="/egresos" element={<AllEgresos />} />
          <Route path="/egresos/new" element={<NewEgreso />} />
          <Route path="/egresos/:egresoId" element={<ViewEgreso />} />
          <Route path="/services/new" element={<NewService />} />
          <Route path="/services/new_order" element={<NewServiceOrder />} />
          <Route path="/services/new_field" element={<NewFieldService />} />
          {/* Public: provider capture page, authenticated by link token */}
          <Route path="/captura/:token" element={<FieldCapture />} />
          <Route path="/s/:token" element={<FieldCapture />} />
          {/* Public: trasladista expense tickets, authenticated by link token */}
          <Route path="/gastos/:token" element={<TrasladoGastos />} />
          <Route path="/g/:token" element={<TrasladoGastos />} />
          <Route path="/vehicle_transfers" element={<Traslados />} />
          <Route path="/vehicle_transfers/new" element={<NewTraslado />} />
          <Route path="/vehicle_transfers/:trasladoId" element={<Traslado />} />
          <Route path="/vehicle_transfers/:trasladoId/edit" element={<NewTraslado />} />
          <Route path="/trasladistas" element={<Trasladistas />} />
          <Route path="/gastos_facturas" element={<GastosFacturas />} />
          <Route path="/casetas_tag" element={<CasetasTag />} />
          <Route path="/traslados_pendientes" element={<TrasladosPendientes />} />
          <Route path="/traslado_rates" element={<TrasladoRates />} />
          <Route path="/traslado_recovery" element={<TrasladoRecovery />} />
          <Route path="/services/:serviceId" element={<ViewService />} />
          <Route path="/checklists" element={<Checklists />} />
          <Route path="/checklists/:checklistId" element={<Checklist />} />
          <Route path="/pending_reports" element={<PendingReports />} />
          <Route path="/lavados" element={<Washes />} />
          <Route path="/lavados/:washId" element={<Wash />} />
          <Route path="/services/precheck" element={<ServicePrecheck />} />
          <Route path="/service_providers" element={<AllServiceProviders />} />
          <Route
            path="/service_providers/new"
            element={<NewServiceProvider />}
          />
          <Route
            path="/service_providers/:providerId"
            element={<ViewServiceProvider />}
          />
          <Route path="/insurance/all" element={<AllInsurancePolicies />} />
          <Route path="/insurance/new" element={<NewPolicy />} />
          <Route path="/insurance/:policyId" element={<Policy />} />
          <Route path="/documentos_escaneados" element={<ScannedDocuments />} />
          <Route path="/validaciones" element={<Validaciones />} />
          <Route path="/validaciones/new" element={<NewValidacion />} />
          <Route
            path="/validaciones/:validacionId"
            element={<ViewValidacion />}
          />
          <Route path="/cash" element={<CashDaily />} />
          <Route path="/conciliacion-bancaria" element={<ConciliacionBancaria />} />
          <Route path="/conciliation" element={<ConciliationDashboard />} />
          <Route path="/afirme_payments" element={<AfirmePayments />} />
          <Route path="/deposit_transfers" element={<PendingDepositTransfers />} />
          <Route path="/payments/new" element={<CreatePayment />} />
          <Route path="/payments/received" element={<PagosRecibidos />} />
          <Route path="/payments/statement" element={<FintocStatement />} />
          <Route path="/invoices" element={<Invoices />} />
          <Route path="/invoicing/auto" element={<AutoInvoicingDashboard />} />
          <Route path="/invoicing/create" element={<CreateInvoice />} />
          <Route path="/invoicing/groups/:groupId" element={<InvoicingGroupDetail />} />
          <Route path="/users" element={<Users />} />
          <Route path="/settings/menu" element={<MenuSettings />} />
          <Route path="/settings/company" element={<CompanySettings />} />
          <Route path="/users/:userId" element={<EditUser />} />
          <Route path="/invoice_tracker" element={<InvoiceTracker />} />
          <Route path="/infractions" element={<Infractions />} />
          <Route path="/infractions/new" element={<NewInfraction />} />
          <Route path="/infractions/:infractionId" element={<Infraction />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/reports/:reportId" element={<Report />} />
        </Routes>
      </BrowserRouter>
      </BranchContextProvider>
    </AuthContextProvider>
  );
}

export default App;
